import { Subject } from "rxjs";
import apiResponse from "../../../../../services/apiResponse";
import IndexRepository from "../Repositories/IndexRepository";

class IndexBloc {
  indexChannel = new Subject();
  workUnitChannel = new Subject();
  employeeStatusChannel = new Subject();
  exportExcelChannel = new Subject();
  configChannel = new Subject();

  repository = new IndexRepository();

  constructor() {
    this.indexChannel.next({ status: apiResponse.INITIAL });
    this.employeeStatusChannel.next({ status: apiResponse.INITIAL });
    this.exportExcelChannel.next({ status: apiResponse.INITIAL });
    this.workUnitChannel.next({ status: apiResponse.INITIAL });
    this.configChannel.next({ status: apiResponse.INITIAL });
  }

  fetchExportExcel = async (query) => {
    try {
      this.exportExcelChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchExportExcel(query)
        .then((result) => {
          this.exportExcelChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.exportExcelChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "channel unsubscribed");
    }
  };

  fetchWorkUnit = async (query) => {
    try {
      this.workUnitChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchWorkUnit(query)
        .then((result) => {
          this.workUnitChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.workUnitChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("rxjs", "channel unsubscribed");
    }
  };

  fetchEmployeeStatus = async (query) => {
    try {
      this.employeeStatusChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchEmployeeStatus(query)
        .then((result) => {
          this.employeeStatusChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.employeeStatusChannel.next({
            status: apiResponse.ERROR,
            data: error,
          });
        });
    } catch (error) {
      console.log("rxjs", "channel unsubscribed");
    }
  };

  fetchWorkUnit = async (query) => {
    try {
      this.workUnitChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchWorkUnit(query)
        .then((result) => {
          this.workUnitChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.workUnitChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("rxjs", "channel unsubscribed");
    }
  };

  fetchConfig = async (query) => {
    try {
      this.configChannel.next({ status: apiResponse.LOADING });
      await this.repository
        .fetchConfig(query)
        .then((result) => {
          this.configChannel.next({
            status: apiResponse.COMPLETED,
            data: result,
          });
        })
        .catch((error) => {
          this.configChannel.next({ status: apiResponse.ERROR, data: error });
        });
    } catch (error) {
      console.log("rxjs", "channel unsubscribed");
    }
  };
}

export default IndexBloc;
